var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('BackToTop'),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loading-box df fdc aic jcc"},[_vm._m(0),_c('p',{staticClass:"mt-12"},[_vm._v(_vm._s(_vm.$t(_vm.loadingText)))])])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_c('img',{attrs:{"src":require("@/assets/images/img/loader.gif"),"alt":""}})])
}]

export { render, staticRenderFns }